import { render, staticRenderFns } from "./novaProposta.vue?vue&type=template&id=c5e90ff4&scoped=true"
import script from "./novaProposta.vue?vue&type=script&lang=js"
export * from "./novaProposta.vue?vue&type=script&lang=js"
import style0 from "./novaProposta.vue?vue&type=style&index=0&id=c5e90ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e90ff4",
  null
  
)

export default component.exports